import Vue from 'vue';
const {
  $gettext
} = Vue.prototype;
export default {
  defaultEntity: {
    firstName: '',
    company: '',
    kremmore: '',
    lastName: '',
    position: '',
    message: '',
    country: '',
    telephone: '',
  },
  layout() {
    const {
      state
    } = Vue.prototype.store;
    const {
      rules
    } = state.toggle;
    const countryStorage = localStorage.country ? JSON.parse(localStorage.country) : null;
    return [
      {
        column: 3,
        fieldName: 'firstName',
        label: $gettext('First name'),
        rules: [rules.required]
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'company',
        label: $gettext('Company'),
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'kremmore',
        label: $gettext('Email'),
        rules: [rules.required, rules.email]
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'lastName',
        label: $gettext('Last name'),
        rules: [rules.required]
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'position',
        label: $gettext('Position'),
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'message',
        type: 'textareaCustom',
        label: $gettext('Vote Message'),
        placeholder: '',
        row: '4',
        rowHeight: '33'
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'country',
        label: $gettext('Country'),
      },
      {
        column: 1,
        type: 'empty'
      },
      {
        column: 3,
        fieldName: 'telephone',
        type: 'telephone',
        label: $gettext('Telephone'),
        countryCode: ( countryStorage && countryStorage.id ) || null,
      },
    ];
  }
};